const state = () => ({
  educationpack:null,
  educationpacks:[],
});
const getters = {
  educationpack(state){
    return state.educationpack
  },
  educationpacks(state){
    return state.educationpacks
  },
};
const  mutations =  {
  SET_EDUCATION_PACK(state,data){
    state.educationpack = data
  },
  SET_EDUCATION_PACKS(state,data){
    state.educationpacks = data
  },
};
const actions =  {
  setEducationPack({commit},data)  {
    commit("SET_EDUCATION_PACK",data)
  },
  setEducationPacks({commit},data)  {
    commit("SET_EDUCATION_PACKS",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

